/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';

import { BadgesList, ListMap, Item, Icon, Labels, Title, SecondaryTitle } from './styles';

export default class TrustBadgesList extends PureComponent {
    render() {
        const { list } = this.props;

        return (
            <BadgesList>
                {list.length !== 0 && (
                    <ListMap>
                        {list.map((item, i) => (
                            <Item href={item.url} target="_blank" key={i}>
                                <Icon src={item.icon} alt="trust icon" />
                                <Labels>
                                    <Title>{item.title}</Title>
                                    <SecondaryTitle>{item.secondaryTitle}</SecondaryTitle>
                                </Labels>
                            </Item>
                        ))}
                    </ListMap>
                )}
            </BadgesList>
        );
    }
}
